import "./styles.scss";
import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper";

import CartTicket from "../CartTicket";
import useDeviceDetect from "../../hook/useDeviceDetect";
import { useTheme } from "../../hook/useThemes";
import { activeEventFathom } from "../../utils/utils";

interface IPropsListCartTicket {
  dataList?: any[];
  onChangeIndex?: (index: number) => void;
}

const SliderNavIcon = () => {
  return (
    <svg
      width="61"
      height="107"
      viewBox="0 0 61 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.5922 53.492L2.24332 93.9347C-0.747773 96.9299 -0.747772 101.768 2.24332 104.763C3.66819 106.195 5.60817 107 7.63259 107C9.65701 107 11.597 106.195 13.0219 104.763L58.7562 58.9141C61.7473 55.9189 61.7473 51.0811 58.7562 48.0859L13.0219 2.23711C11.597 0.805343 9.657 7.20727e-06 7.63258 7.29576e-06C5.60817 7.38425e-06 3.66818 0.805343 2.24331 2.23711C-0.747777 5.23236 -0.747776 10.0701 2.24331 13.0653L42.5922 53.492Z"
        fill="#555555"
      />
    </svg>
  );
};

export default function ListCartTicket({
  dataList: items,
  onChangeIndex,
}: IPropsListCartTicket) {
  const { isDesktopMin } = useDeviceDetect();
  const { settingCard } = useTheme();
  const { tracker = "vertical" } = settingCard;

  useEffect(() => {
    if (!isDesktopMin) {
      onChangeIndex(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDesktopMin]);

  if (!items?.length) {
    return <></>;
  }

  return (
    <div
      className={`wrapper-list-card-ticket ${
        isDesktopMin && "wrapper-list-card-ticket-min"
      } wrapper-list-card-ticket-${tracker}
      ${isDesktopMin && `wrapper-list-card-ticket-min-${tracker}`}
      `}
    >
      <div
        className="swiper-button-prev"
        onClick={() => activeEventFathom("PlayPage-LeftArrow")}
      >
        <SliderNavIcon />
      </div>

      {!isDesktopMin && (
        <Swiper
          navigation={{
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
          }}
          modules={[Navigation]}
          className="desktop-card-view"
          slidesPerView={3}
          spaceBetween={18}
          // onActiveIndexChange={(e)=>console.log(e)}
          onSlideChange={(e) => onChangeIndex?.(e.activeIndex || 0)}
        >
          {items.map((item, index: number) => {
            return (
              <SwiperSlide key={item?.id}>
                <CartTicket zIndex={index} contest={item} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}

      {isDesktopMin && (
        <Swiper
          navigation={{
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
          }}
          className="desktop-card-view desktop-card-view-desktop-min"
          slidesPerView={"auto"}
          spaceBetween={18}
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          coverflowEffect={{
            rotate: 0,
            stretch: 100,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          modules={[EffectCoverflow, Navigation]}
          onAfterInit={(swiper) => swiper.slideNext()}
          onSlideChange={(e) => onChangeIndex?.(e.activeIndex || 0)}
        >
          {items.map((item, index: number) => {
            return (
              <SwiperSlide key={item?.id}>
                <CartTicket zIndex={index} contest={item} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}

      <div
        className="swiper-button-next"
        onClick={() => activeEventFathom("PlayPage-RightArrow")}
      >
        <SliderNavIcon />
      </div>
    </div>
  );
}
